import StripeCustomCheckout from './StripeCustomCheckout';

export default StripeCustomCheckout;
